import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the UnitAnnnounceScreen state domain
 */

const selectUnitAnnnounceScreenDomain = state =>
  state.unitAnnounceScreen || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by UnitAnnnounceScreen
 */

const makeSelectUnitAnnnounceScreen = () =>
  createSelector(
    selectUnitAnnnounceScreenDomain,
    substate => substate,
  );

export default makeSelectUnitAnnnounceScreen;
export { selectUnitAnnnounceScreenDomain };
